import { Box, createMuiTheme, makeStyles, Paper } from '@material-ui/core';
import React, { FC } from 'react';
// import brazeSetting from 'src/images/braze-setting.gif';
import closeButton from 'src/images/close-button.png';
import { ReactComponent as Instruction } from 'src/images/instruction.svg';
import Instruction01 from 'src/images/instruction01.png';
import Instruction02 from 'src/images/instruction02.png';
import Instruction03 from 'src/images/instruction03.png';

interface InstructionModalProps {
  handleClose: React.MouseEventHandler<HTMLButtonElement>;
}

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1400,
      xl: 1920
    }
  }
});

const useStyles = makeStyles(() => ({
  step: {
    fontFamily: 'Archivo',
    fontSize: 17,
    fontWeight: 600,
    color: '#000000',
    marginBottom: 10
  },
  primary: {
    color: '#4778FF'
  },
  normal: {
    fontWeight: 400
  },
  bold: {
    fontWeight: 700
  },
  primaryBold: {
    color: '#4778FF',
    fontWeight: 700
  },
  ul: {
    marginLeft: 20,
    marginBottom: 10,
    fontSize: 13,
    lineHeight: 1.8,
    fontFamily: 'Roboto'
  },
  paper: {
    width: '45vw',
    [theme.breakpoints.down('lg')]: {
      width: 630
    },
    boxShadow: 'none',
    overflow: 'hidden'
  }
}));

const InstructionModal: FC<InstructionModalProps> = props => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '22px 72px'
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <Instruction style={{ width: 35, height: 35, marginRight: 15 }} />
          <div
            style={{
              fontFamily: 'Archivo',
              fontWeight: 700,
              fontSize: 21,
              color: '#19191A'
            }}
          >
            Instruction
          </div>
        </Box>
        <button
          onClick={props.handleClose}
          style={{ background: '#fff', border: 'none', cursor: 'pointer' }}
        >
          <img
            alt="close"
            src={closeButton}
            style={{ width: 14, height: 14 }}
          />
        </button>
      </Box>
      <Box>
        <Box
          style={{
            width: '100%',
            background: '#f2f2f2',
            padding: '7px 72px 13px',
            textAlign: 'center'
          }}
        >
          {/* <a
            href="https://image.inappmessage.com/sample/braze-setting.gif"
            target="_blank"
          >
            <img
              alt="braze-setting"
              src={brazeSetting}
              style={{ width: '75%' }}
            />
          </a> */}
        </Box>
        <Paper
          style={{
            boxShadow: 'none',
            maxHeight: '40vh',
            overflowY: 'scroll',
            padding: '30px 72px 25px'
          }}
        >
          <p
            style={{
              fontSize: 20,
              fontFamily: 'Archivo',
              fontWeight: 'bold',
              marginBottom: 40
            }}
          >
            Setting Braze In-App Message with{' '}
            <span className={classes.primary}>IAM HTML Codes</span>
          </p>
          <p className={classes.step}>
            <span className={classes.normal}>Step 01 : </span>
            <span className={classes.primary}>Copy</span> code from IAM Studio
            page
          </p>
          <ul className={classes.ul} style={{ marginBottom: 25 }}>
            <li>
              Click the<span className={classes.bold}> Export </span>Button and
              copy the codes with click the
              <span className={classes.bold}> Copy code </span>Buttons
            </li>
          </ul>
          <p className={classes.step}>
            <span className={classes.normal}>Step 02 : </span>
            <span className={classes.primary}>Create a campaign </span>
            from Braze
          </p>
          <ul className={classes.ul}>
            <li>
              Click<span className={classes.bold}> Create Campaign </span>-{'>'}{' '}
              In-App Messaging to open a new messaging wizard for in-app message
              campaigns
            </li>
            <li>Name the Campaign from Campaign Details sections</li>
            <li>
              Choose In-App Message Platfrom to
              <span className={classes.primaryBold}> Mobile Apps</span>
            </li>
          </ul>
          <img
            src={Instruction01}
            alt="Instruction01"
            style={{
              marginTop: 5,
              marginBottom: 20,
              width: 440
            }}
          />
          <ul className={classes.ul}>
            <li>
              Select the Message Type to
              <span className={classes.primaryBold}> Custom Code</span>
            </li>
          </ul>
          <img
            src={Instruction02}
            alt="Instruction02"
            style={{ marginTop: 5, marginBottom: 20, width: 440 }}
          />
          <ul className={classes.ul}>
            <li>
              <span className={classes.primaryBold}>Paste </span>the IAM HTML
              Codes in the Braze Custom Code HTML Input Box
            </li>
          </ul>
          <img
            src={Instruction03}
            alt="Instruction03"
            style={{ marginTop: 5, width: 440 }}
          />
          <p
            className={classes.step}
            style={{ marginBottom: 20, marginTop: 20 }}
          >
            <span className={classes.normal}>Step 03 : </span>You’re
            <span className={classes.primary}> all set </span> now!
          </p>
        </Paper>
      </Box>
    </Paper>
  );
};

export default InstructionModal;
